export const deClientPortalAppraiserSelectionSection = {
    title: 'Kein/e Gutachter/in zuständig',
    description: 'Fügen Sie mindestens einen Gutachter/eine Gutachterin als Beobachter/in hinzu:',
    loading: 'Lade Gutachter/innen...',
    emptyState: 'Keine verknüpften Gutachter/innen für diesen Auftrag verfügbar.',
    fieldLabel: 'Gutachter/in',
}
